module.exports = __webpack_public_path__ + "img/warning.d74b14f2.svg";